import * as t from "io-ts";

export const ChatTokenValidator = t.intersection([
  t.type({
    token: t.string,
    sendbirdUserId: t.string,
  }),
  t.partial({
    expiresDttm: t.number,
  }),
]);

export type ChatToken = t.TypeOf<typeof ChatTokenValidator>;
